import { useState, useEffect } from 'react';
import '../Donate/Donate.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { States } from '../common/States';
import PropTypes from 'prop-types';
import { navigateForm } from '../Helpers/FormHelper'


export function FormPayee(
  {
    isBehalf, isSecondPart, formTitle, bindFirstName, errorFirstName,
    bindLastName, errorLastName, bindAddress1, errorAddress1, bindAddress2,
    bindCity, errorCity, bindPostalState, errorPostalState, bindPostalCode,
    errorPostalCode, bindPhone, errorPhone, bindEmailAddress, errorEmailAddress,
    isMe, isMemorial, setIsSecondPart, bindPayeeEmailOptIn
  }) {
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    if (isBehalf !== undefined) {
      setIsShow(isBehalf);
    } else {
      if (isMe) {
        setIsShow(false);
      } else {
        setIsShow(true);
      }
    }
  }, [isBehalf, isMe])
  return (
    <div className={`payeeInput ${(isShow && !isSecondPart) ? "hidden" : ""}`}>
      <h2 className="linkHeader">{`${formTitle}`}</h2>
      <div className="form-group">
        <label className="control-label">First Name</label>
        <input className="form-control" name="First Name" type="text" {...bindFirstName} />
        <div className="formError" style={{ color: "red" }}>
          {errorFirstName.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Last Name</label>
        <input className="form-control" name="Last Name" type="text" {...bindLastName} />
        <div className="formError" style={{ color: "red" }}>
          {errorLastName.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Address Line 1</label>
        <input className="form-control" name="Address Line 1" type="text" {...bindAddress1} />
        <div className="formError" style={{ color: "red" }}>
          {errorAddress1.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Address Line 2</label>
        <input className="form-control" name="Address Line 2" type="text" {...bindAddress2} />
      </div>
      <div className="form-group">
        <label className="control-label">City</label>
        <input className="form-control" name="City" type="text" {...bindCity} />
        <div className="formError" style={{ color: "red" }}>
          {errorCity.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">State</label>
        <States bindValues={bindPostalState} />
        <div className="formError" style={{ color: "red" }}>
          {errorPostalState.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Postal Code</label>
        <input className="form-control" name="Postal Code" type="text" {...bindPostalCode} />
        <div className="formError" style={{ color: "red" }}>
          {errorPostalCode.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Phone</label>
        <input className="form-control" name="Phone" type="text" {...bindPhone} />
        <div className="formError" style={{ color: "red" }}>
          {errorPhone.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="control-label">Email Address</label>
        <input className="form-control" name="Email" type="text" {...bindEmailAddress} />
        <div className="formError" style={{ color: "red" }}>
          {errorEmailAddress.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="payeeEmailOptIn">
          <input type="checkbox" className="form-check-input" id="payeeEmailOptIn" {...bindPayeeEmailOptIn} /> I would like to receive emails about news and information from the BLM Wild Horse and Burro Program
        </label>
      </div>
      <div className={`row ${(isMe || isMemorial) ? "hidden" : ""}`}>
        <div className="col-sm-12 text-start">
          <Link to="" onClick={(e) => navigateForm(e, "prev", setIsSecondPart)} className="btn blm-btn-primary left">
            <FontAwesomeIcon icon={["fa", "angle-double-left"]} /> Previous
          </Link>
        </div>
      </div>
    </div>
  );

}

FormPayee.propTypes = {
  isBehalf: PropTypes.bool,
  isSecondPart: PropTypes.bool.isRequired,
  formTitle: PropTypes.string.isRequired,
  bindFirstName: PropTypes.object.isRequired,
  errorFirstName: PropTypes.array.isRequired,
  bindLastName: PropTypes.object.isRequired,
  errorLastName: PropTypes.array.isRequired,
  bindAddress1: PropTypes.object.isRequired,
  errorAddress1: PropTypes.array.isRequired,
  bindAddress2: PropTypes.object.isRequired,
  bindCity: PropTypes.object.isRequired,
  errorCity: PropTypes.array.isRequired,
  bindPostalState: PropTypes.object.isRequired,
  errorPostalState: PropTypes.array.isRequired,
  bindPostalCode: PropTypes.object.isRequired,
  errorPostalCode: PropTypes.array.isRequired,
  bindPhone: PropTypes.object.isRequired,
  errorPhone: PropTypes.array.isRequired,
  bindEmailAddress: PropTypes.object.isRequired,
  errorEmailAddress: PropTypes.array.isRequired,
  bindPayeeEmailOptIn: PropTypes.bool,
  isMe: PropTypes.bool,
  isMemorial: PropTypes.bool,
  setIsSecondPart: PropTypes.func.isRequired
}

